import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import SelectWrapper from '../SelectWrapper';
import styles from './styles';
// The default CT Select is just a CT-skinned version of react-select
const Select = props => (React.createElement(SelectWrapper, Object.assign({}, props, { styles: Object.assign(Object.assign({}, props.styles), styles), selectedSelect: ReactSelect })));
export default Select;
Select.propTypes = {
    styles: PropTypes.object,
};
